import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const PageBanner = ({ eyebrow, title, description, testId }) => (
  <div data-testid={testId} className="bg-brand-navy pt-[84px]">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 md:py-20">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="flex items-center gap-4"
      >
        <span className="h-px w-12 bg-brand-cyan" />
        <span className="text-xs font-bold uppercase tracking-[0.3em] text-brand-cyan">{eyebrow}</span>
      </motion.div>
      <span className="block overflow-hidden mt-5 pb-1">
        <motion.h1
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
          className="font-display text-4xl md:text-5xl lg:text-6xl text-white tracking-tight"
        >
          {title}
        </motion.h1>
      </span>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45, ease: EASE }}
          className="mt-5 max-w-2xl text-base md:text-lg leading-relaxed text-slate-300"
        >
          {description}
        </motion.p>
      )}
    </div>
  </div>
);
